/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {forwardRef, useImperativeHandle, useRef} from "react";
// react plugin for creating notifications over the report
import NotificationAlert from "react-notification-alert";

// reactstrap components

const Notifications = forwardRef((props, ref) => {
    const notificationAlertRef = useRef()

    const notify = (place) => {
        var color = props.color
        var type;
        switch (color) {
            case 1:
                type = "primary";
                break;
            case 2:
                type = "success";
                break;
            case 3:
                type = "danger";
                break;
            case 4:
                type = "warning";
                break;
            case 5:
                type = "info";
                break;
            default:
                break;
        }
        var options = {};
        options = {
            place: 'tr',
            message: (
                <div>
                    <div>
                        {props.text}
                    </div>
                </div>
            ),
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 7,
        };
        notificationAlertRef.current.notificationAlert(options);
    };
    useImperativeHandle(ref, () => ({
        notify
    }));
    return (
        <>
            <div className="content">
                <div className="react-notification-alert-container text-right">
                    <NotificationAlert ref={notificationAlertRef}/>
                </div>
            </div>
        </>
    );
})

export default Notifications;
